import { Link } from "react-router-dom";
import { MessageSquare, ArrowUpRight, ShieldCheck, FileDown } from "lucide-react";
import { SectionHead, Reveal, Crosshair } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const ChinaPartner = () => {
  const { lang, t } = useLang();
  const c = t.china;
  const q = lang === "en" ? "" : `?lang=${lang}`;
  return (
    <section id="china" className="relative overflow-hidden bg-ink bp-grid-dark py-24 sm:py-32 border-y border-[#f8f7f4]/10" data-testid="china-section">
      <Crosshair className="top-6 left-6" />
      <Crosshair className="bottom-6 right-6" />
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <SectionHead dark eyebrow={c.eyebrow} title={c.title} desc={c.desc} testid="china" />
            <div className="mt-8 flex flex-wrap gap-2" data-testid="china-trust">
              {c.trust.map((x) => (
                <span key={x} className="inline-flex items-center gap-1.5 border border-[#f8f7f4]/20 px-3 py-1.5 font-mono-tech text-[10px] uppercase tracking-[0.15em] text-[#f8f7f4]/75">
                  <ShieldCheck className="h-3.5 w-3.5 text-[#e63946]" /> {x}
                </span>
              ))}
            </div>
          </div>
          <Reveal delay={0.1} className="lg:col-span-5">
            <div className="chamfer border border-[#f8f7f4]/15 bg-[#f8f7f4] p-7 sm:p-9" data-testid="china-wechat-card">
              <p className="flex items-center gap-2 font-mono-tech text-[0.65rem] tracking-[0.28em] uppercase text-red-brand">
                <MessageSquare className="h-4 w-4" /> {c.wechatLabel}
              </p>
              <p className="mt-3 font-display text-3xl sm:text-4xl font-black tracking-tight text-ink" data-testid="china-wechat-id">{c.wechat}</p>
              <p className="mt-2 text-sm text-[#525964]">{c.wechatHint}</p>
              <div className="mt-6 flex flex-wrap gap-2.5">
                <Link to={`/partners${q}#booking`} data-testid="china-cta-booking" className="chamfer-sm inline-flex items-center gap-2 bg-red-brand px-5 py-3 font-mono-tech text-[11px] font-semibold uppercase tracking-[0.15em] text-[#f8f7f4] hover:bg-[#5f1019] transition-colors">
                  {c.cta} <ArrowUpRight className="h-4 w-4" />
                </Link>
                <a href="https://hadronenergy.pl" target="_blank" rel="noopener noreferrer" data-testid="china-cta-hadron" className="chamfer-sm inline-flex items-center gap-2 border border-technical px-4 py-3 font-mono-tech text-[10.5px] uppercase tracking-[0.15em] text-ink hover:border-red-brand transition-colors">
                  {c.cta2}
                </a>
              </div>
              <a href="/assets/MargTor-Partnership-Brief-ZH.pdf" target="_blank" rel="noopener noreferrer" data-testid="china-brief-pdf" className="mt-4 inline-flex items-center gap-2 font-mono-tech text-[10.5px] uppercase tracking-[0.15em] text-red-brand hover:text-ink transition-colors">
                <FileDown className="h-4 w-4" /> 合作简介 PDF（中文，一页） · Partnership brief (ZH)
              </a>
              <p className="mt-4 font-mono-tech text-[10px] tracking-[0.15em] text-[#525964]">+254 719 180 236 · +254 708 189 175 · Nairobi</p>
            </div>
          </Reveal>
        </div>
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#f8f7f4]/15 border border-[#f8f7f4]/15" data-testid="china-points">
          {c.points.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.06} className="bg-ink p-6 sm:p-7">
              <span className="font-mono-tech text-[10px] font-semibold text-[#e63946]">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-3 font-display text-base sm:text-lg font-bold tracking-tight text-[#f8f7f4]">{p.title}</h3>
              <p className="mt-2.5 text-xs sm:text-sm leading-relaxed text-[#f8f7f4]/60">{p.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
